// extracted by mini-css-extract-plugin
module.exports = {"logoItem":"LogoSlide_logoItem__L0U0t","defaultLogo":"LogoSlide_defaultLogo__avTgv","hoverLogo":"LogoSlide_hoverLogo__BFntF"};